import Actions from '../../odata/actions';

const actions = new Actions('pallet', 'pallets');

export default actions;
